import React, { createContext, useContext, FC } from 'react';
import { noop } from 'lodash';

interface WPImportStatusSubscriptionContextProps {
  workPackageImportStatus: string | null;
  setWorkPackageImportStatus: React.Dispatch<React.SetStateAction<string>>;
}

const WPImportStatusSubscriptionContextPrivate = createContext<WPImportStatusSubscriptionContextProps>({
  workPackageImportStatus: '',
  setWorkPackageImportStatus: noop,
});

const { Provider } = WPImportStatusSubscriptionContextPrivate;

export const useWPImportStatusSubscriptionContext = () => {
  return useContext(WPImportStatusSubscriptionContextPrivate);
};

export const WPImportStatusSubscriptionContext: FC<WPImportStatusSubscriptionContextProps> = ({
  children,
  ...subscriptionContextProps
}) => {
  return <Provider value={subscriptionContextProps}>{children}</Provider>;
};
